'use strict'

const {NEW_MENU} = require('@wix/component-migration/migrateStylableHorizontalMenuToNewMenu')

const entriesToChange = {
    componentType: NEW_MENU.componentType,
    skin: NEW_MENU.skin,
    type: NEW_MENU.type
}

const keysToKeep = [
    'id',
    'styleId',
    'layout',
    'classnamesQuery',
    'transformationQuery',
    'connectionQuery',
    'dataQuery',
    'layoutQuery',
    'slotsQuery',
    'components'
]

const migrateToNewMenuComponent = component => {
    // TODO: update data type
    Object.keys(component).forEach(key => keysToKeep.includes(key) || delete component[key])
    Object.entries(entriesToChange).forEach(([key, value]) => (component[key] = value))
}

module.exports = {
    NEW_MENU,
    migrateToNewMenuComponent
}
